module.exports = __webpack_public_path__ + "img/eatyeet.91cb4072.jpg";